/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 3/4/21
 * Copyright All Rights Reserved
 */
import { Auth } from 'aws-amplify';
import { SubmissionError } from 'redux-form';
import ResetPasswordFormPage2 from './ResetPasswordFormPage2';
import connectPasswordResetFormPage from '../support/connectPasswordResetFormPage';
import {
  COGNITO_LIMIT_EXCEEDED_EXCEPTION,
  COGNITO_CODE_MISMATCH_EXCEPTION,
} from 'constants/cognitoErrorCodes';
import { PROBLEM_WITH_REQUEST } from 'constants/errorMessages';

const onSubmit = (values, dispatch, nextPage) =>
  Auth.forgotPasswordSubmit(values.email, values.confirmationCode, values.newPassword)
    .then(() => { nextPage(); })
    .catch((error) => {
      const message =
        [COGNITO_CODE_MISMATCH_EXCEPTION, COGNITO_LIMIT_EXCEEDED_EXCEPTION].includes(error.code)
          ? error.message
          : PROBLEM_WITH_REQUEST;
      return Promise.reject(new SubmissionError({ _error: message }));
    });

export default connectPasswordResetFormPage({
  onSubmit,
})(ResetPasswordFormPage2);



// WEBPACK FOOTER //
// ./js/components/pages/ResetPassword/ResetPasswordForm/ResetPasswordFormPage2/index.js